// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Page-root-q_n_Z {
  padding-left: 20px;
  padding-right: 20px;
  min-height: 50vh
}

.Page-container-uko9c {
  margin: 0 auto;
  padding: 0 0 40px;
  max-width: var(--max-container-width);
}

.Page-container-uko9c h1 {
  text-align: start;
}

@media screen and (max-width:1200px) {
  .Page-container-uko9c {
    padding: 85px 0 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Page/Page.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".root {\n  padding-left: 20px;\n  padding-right: 20px;\n  min-height: 50vh\n}\n\n.container {\n  margin: 0 auto;\n  padding: 0 0 40px;\n  max-width: var(--max-container-width);\n}\n\n.container h1 {\n  text-align: start;\n}\n\n@media screen and (max-width:1200px) {\n  .container {\n    padding: 85px 0 40px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Page-root-q_n_Z`,
	"container": `Page-container-uko9c`
};
module.exports = ___CSS_LOADER_EXPORT___;
